import { useGetCoursesReviewsQuery } from "../../../../app/features/courses/courses.api";
import IMAGES from "../../../../assets/images";
import ReviewItem from "../../../../components/ui/ReviewItem";
import useError from "../../../../hooks/useError";
import ReviewLoading from "./ReviewLoading";

export default function SuccessStory() {
  // const { limit, page, handlePagination } = useFilters();
  const { data, isLoading, error } = useGetCoursesReviewsQuery({});
  useError(error, "Failed to load reviews list");

  return (
    <section className="bg-gradient-to-l from-theme-white-900 to-theme-white-900 py-20">
      <div className="container mini-container">
        <div
          className="grid gap-6 
                sm:grid-cols-1 
                md:grid-cols-2 
                lg:grid-cols-3 
                auto-rows-fr mb-5"
        >
          {isLoading ? (
            <ReviewLoading />
          ) : (
            data?.items?.map((item, i) => (
              <div key={i} className="flex">
                <ReviewItem
                  img={item.userAvatar || IMAGES.avatar}
                  text={item.comment || ""}
                  name={item.userName || ""}
                  // role={item.userRole || ""}
                  rating={item.rating || 0}
                />
              </div>
            ))
          )}
        </div>

        {/* <CustomPagination
          limit={limit}
          page={page}
          total={100}
          handlePagination={handlePagination}
          prevIcon={<LeftPaginationArrowIcon />}
          nextIcon={<RightPaginationArrowIcon />}
          className="border-none"
          paginationClassName="course_pagination pt-4"
          hidePage
        /> */}
      </div>
    </section>
  );
}
